import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

// todo: refactor the html so it handles the different types of dialogs, right now only warning

declare const gtag: (...args: unknown[]) => void;

@Component({
  selector: "app-verify-email-remind-dialog",
  templateUrl: "./verify-email-remind-dialog.component.html",
})
export class VerifyEmailRemindDialogComponent implements OnInit {
  protected username: string;
  protected domain: string;
  constructor(
    public dialogRef: MatDialogRef<VerifyEmailRemindDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      email: string;
    },
  ) {
    this.splitEmail();
  }

  ngOnInit() {
    if (typeof gtag !== "undefined") {
      gtag("event", "conversion", {
        send_to: "AW-18157220448/qQAYCJWFvascEODkhNJD",
        value: 1.0,
        currency: "AUD",
        transaction_id: this.data?.email,
      });
    }
  }

  splitEmail() {
    const email = this.data?.email.split("@");
    this.username = email[0];
    this.domain = email[1];
  }
}
